module.exports = __webpack_public_path__ + "img/DK_DragonKnife_correctAngle.917ed208.png";